module.exports = __webpack_public_path__ + "img/currency5.47c20ad0.png";